// extracted by mini-css-extract-plugin
export default {"outerDiv":"units-page_outerDiv__7KhwE","cardOuterDiv":"units-page_cardOuterDiv__zWWg1","cNameText":"units-page_cNameText__R42uk","cDescText":"units-page_cDescText__IzLGJ"};